import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_UPLOADED_ACKNOWLEDGEMENTS);
var axios_instance_by_quarter = get_axios_instance(api_variables.SERVICE_UPLOADED_ACKNOWLEDGEMENTS_BY_QUARTER);
var axios_instance_delete = get_axios_instance(api_variables.SERVICE_UPLOADED_ACKNOWLEDGEMENTS_DELETE);

const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    add: (state, payload) => {
        state.data.push(payload);
    },

    updateById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i][_pk_name] === payload.id) {
                state.data.splice(i, 1, payload);
            }
        }
    },

    removeById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i][_pk_name] == payload) {
                state.data.splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
        //console.log("[state/dashboard/organisation/utilities/form24Qacknowledgement/fetchAll] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(``, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            //console.log("[state/dashboard/organisation/utilities/form24Qacknowledgement/fetchAll] res: ", res);
            if (res.status == 200) {
                //console.log('rows data', res.data.rows)
                //commit("set", res.data.rows);
            }

            return res;
        } catch (error) {
            //console.log('error',error);
            throw errorHandler(error.response);
        }
    },

    async fetchAcksByQuarter({ commit }, payload) {
        //console.log("[state/dashboard/organisation/utilities/form24Qacknowledgement/fetchAcksByQuarter] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance_by_quarter.get(``, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            //console.log("[state/dashboard/organisation/utilities/form24Qacknowledgement/fetchAcksByQuarter] res: ", res);
            if (res.status == 200) {
                //console.log('rows data', res.data.rows)
                //commit("set", res.data.rows);
            }

            return res;
        } catch (error) {
            //console.log('error',error);
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        //console.log("[state/dashboard/organisation/utilities/form24Qacknowledgement/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.post(`/`, payload);
            commit("setSaving", false);
            //console.log("[state/dashboard/organisation/utilities/form24Qacknowledgement/create] res: ", res);
            if (res.status == 200) {
                //commit("addEntity", res.data);
            }
            return res;
        } catch (error) {
            //console.log('error',error);
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, payload) {
        //console.log("[state/dashboard/organisation/utilities/form24Qacknowledgement/delete] Payload:", payload);
        //console.log("[state/dashboard/organisation/utilities/form24Qacknowledgement/delete] Payload:", `/${payload.id}`);
        try {
            commit("setDeleting", true);
            let res = await axios_instance_delete.post('/',{
                    id:payload.id,

            });
            commit("setDeleting", false);
            if (res.status == 200) {
               // commit("removeEntityById", payload.id);
            }
            return res;
        } catch (error) {
            //console.log('error',error);
            throw errorHandler(error.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}